import React, {useMemo} from 'react';
import {useSearchParams} from "react-router-dom";

import {usePrevious} from "react-use";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import ManageOppMeetings from "../../../components/meetings/ManageOppMeetings";
import {Tabs} from "antd";
import MessagesTab from "../../proposals/MessagesTab";
import Project from "../../../models/Project";
import TalentAvailabilityEditTab from "./TalentAvailabilityEditTab";
import TalentRateEditTab from "./TalentRateEditTab";
import TalentMatchScoreEditTab from "./TalentMatchScoreEditTab";
import TalentFixedFeePayoutEditTab from "./TalentFixedFeePayoutEditTab";
import MatchedTalentCoverLetterEditTab from "./MatchedTalentCoverLetterEditTab";


const MatchedTalentPanel = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const previousLocationSearch = usePrevious(searchParams.get('tabView'));

    const {
        isDisabled,
        onAccept,
        onReject,
        onUpdate,
    } = useOpportunity();

    const onUpdateOpp = (params) => {
        return onUpdate(params, props.opportunity)
    }

    const tabs = [
        {
            key: "cover-letter",
            label: "Cover Letter",
            children: (
                <MatchedTalentCoverLetterEditTab opportunity={props.opportunity}/>
            )
        },
        // {
        //     key: "relevant-experience",
        //     label: "Relevant Experience",
        //     children: (
        //         <div className={TB.mapClass({
        //             disabled: isDisabled
        //         })}>
        //             <TalentRelevantExpEditTab opportunity={props.opportunity}/>
        //         </div>
        //     )
        // },
        ...(
            props.opportunity.isFixedFee() ? [
                {
                    key: "payout",
                    label: "Payout",
                    children: (
                        <div className={TB.mapClass({
                            disabled: isDisabled
                        })}>
                            <TalentFixedFeePayoutEditTab opportunity={props.opportunity}/>
                        </div>
                    )
                },
            ] : [
                {
                    key: "availability",
                    label: "Availability",
                    children: (
                        <div className={TB.mapClass({
                            disabled: isDisabled
                        })}>
                            <TalentAvailabilityEditTab opportunity={props.opportunity} disabled={isDisabled} onUpdate={onUpdateOpp}/>
                        </div>
                    )
                },
                {
                    key: "rate",
                    label: "Rate",
                    children: (
                        <div className={TB.mapClass({
                            disabled: isDisabled
                        })}>
                            <TalentRateEditTab opportunity={props.opportunity} disabled={isDisabled} onUpdate={onUpdateOpp}/>
                        </div>
                    )
                },
            ]
        ),
        {
            key: "match-score",
            label: "Match Score",
            children: (
                <div className={TB.mapClass({
                    disabled: isDisabled
                })}>
                    <TalentMatchScoreEditTab opportunity={props.opportunity} />
                </div>
            )
        },
        {
            key: "interviews",
            label: "Interviews",
            children: (
                <div className={TB.mapClass({
                    disabled: isDisabled
                })}>
                    <ManageOppMeetings
                        opportunity={props.opportunity}/>
                </div>
            )
        },
    ]

    const selectedTab = useMemo(() => {
        if (props.selectedTab) return props.selectedTab;
        let tab;
        if (searchParams.has('tabView')) {
            tab = TB.find(tabs, tab => TB.slugify(tab.key) === searchParams.get('tabView'));
        }
        if (!tab) {
            tab = previousLocationSearch || TB.first(tabs)
        }
        return tab.key;
    }, [location.search, props.selectedTab]);

    const setSelectedTab = (tab) => {
        if (props.onTabChange) {
            return props.onTabChange(tab)
        }
        let params = new URLSearchParams(searchParams);
        params.set('tabView', tab);
        return setSearchParams(params, { replace: true })
    };

    return (
        <div className="proposal-container opportunity-proposal agency-opp-proposal">


            <div className="flex flex-row items-stretch">
                <div className="flex-grow">
                    <Tabs items={tabs} activeKey={selectedTab} onChange={setSelectedTab}/>
                </div>
                <div className="agency-messsage-container">
                    <div className="proposal-messages candidate-messages">
                        <MessagesTab
                            hasPermission={true}
                            opportunity={props.opportunity}
                            project={Project.make({...props.opportunity.project})}
                            onFetchSuccess={() => {
                                // setOpportunity(
                                //     Opportunity.make({
                                //         ...props.opportunity,
                                //         unread_messages_count: 0
                                //     })
                                // )
                            }}
                        />
                    </div>
                </div>
            </div>



        </div>
    )
}

export default MatchedTalentPanel;